import { ForwardedRef, forwardRef } from "react";

type IInput = {
  name: string;
  defaultValue: string;
  styles?: string;
};
const Input = (
  { name, defaultValue, styles }: IInput,
  ref: ForwardedRef<HTMLInputElement>
) => {
  return (
    <input
      ref={ref}
      type="text"
      name={name}
      className={styles}
      defaultValue={defaultValue}
      onFocus={(e) => {
        e.currentTarget.setAttribute("data-type", "U");
      }}
      onChange={() => {}}
    />
  );
};

export default forwardRef<HTMLInputElement, IInput>(Input);
